<template>
  <a-button
    class="upload-type"
    type="primary"
    :loading="uploading"
    @click="uploadFisher"
  >
    本地上传
  </a-button>
</template>
<script setup>
import { onMounted, getCurrentInstance, ref } from 'vue'
import { useFileDialog } from '@vueuse/core'
import { UCloudParams } from './ufile'
import axios from 'axios'
import { getVideoCover } from '@/pages/lifisher/utils/UFile'
const { proxy } = getCurrentInstance()
console.log('proxy', proxy)

const { open, reset, onChange } = useFileDialog({
  accept: '.jpg,.jpeg,.png,.gif,.mp4', // Set to accept only image files
  directory: false, // Select directories instead of files if set true
  multiple: false,
  reset: true
})
const ufile = ref()
const emit = defineEmits(['upload'])

onMounted(() => {
  initUFile()
})
const initUFile = () => {
  if (!proxy.$store.state.isFisher) return
  const { fish_url, token, appkey: appKey } = proxy.$store.state.fisherInfo
  console.log('{fish_url, token, appKey}', { fish_url, token, appKey })
  const getSignature = (data) => {
    return new Promise(resolve => {
      axios.get(`${fish_url}/jmc/file/get-signature`, {
        params: data,
        headers: {
          token,
          AppKey: appKey
        }
      }).then(res => {
        resolve(res.data)
      }).catch(err => {
        resolve(err.data)
      })
    })
  }
  const {
    bucketName,
    bucketUrl,
    tokenPublicKey,
    tokenPrivateKey,
    tokenServerUrl
  } = UCloudParams
  ufile.value = new UCloudUFile(
    bucketName,
    bucketUrl,
    tokenPublicKey,
    tokenPrivateKey,
    tokenServerUrl,
    '',
    '',
    getSignature
  )
}
const uploadFisher = () => {
  console.log('uploadFisher')
  // console.log('ufile.value', ufile.value);
  console.log(proxy.$store.state.fisherInfo)
  const { fish_url, token, appkey } = proxy.$store.state.fisherInfo
  console.log('{fish_url, token, appkey}', { fish_url, token, appkey })
  open()
}
const uploading = ref(false)
onChange((files) => {
  if (!files) return
  console.log('files', files)
  const { fish_url, token, appkey, siteId } = proxy.$store.state.fisherInfo
  const file = files[0]
  if (file) {
    uploading.value = true
    uploadFile(file)
      .then(async (res) => {
        if (file.type.indexOf('video') !== -1) {
          const { coverFile } = await getVideoCover(URL.createObjectURL(res), res.name)
          console.log('coverFile', coverFile)
          const coverRes = await uploadFile(coverFile)
          console.log('coverErr, coverRes', coverRes)
          res.cover = coverRes.cname
        } else {
          res.cover = res.cname
        }
        console.log('uploadFile', res)
        const { cname, type, size, name, cover } = res
        const params = {
          site_id: siteId,
          material: JSON.stringify([{
            url: cname, type, size, material_name: name.split('.')[0], cover_url: cover || ''
          }])
        }
        const [err, res2] = await insert(params)
        console.log('insert', err, res2)
        reset()
        uploading.value = false
        if (err) {
          return
        }
        emit('upload')
      })
      .catch(err => {
        console.log('err', err)
        uploading.value = false
        reset()
      })
  }
})
const uploadFile = (file, onProgress) => {
  return new Promise((resolve, reject) => {
    ufile.value.uploadFile(
      { file },
      (res) => {
        console.log('res', res)
        if (res.code === 200) {
          const { file } = res
          const {
            bucketUrl
          } = UCloudParams
          file.host = bucketUrl
          file.url = `${bucketUrl}/${file.cname}`
          resolve(res.file)
        } else {
          reject(res)
        }
      },
      err => {
        console.log('err', err)
        if (err) {
          reject(err)
        }
      },
      progress => {
        console.log('progress', progress)
        if (onProgress) {
          onProgress(progress)
        }
      }
    )
  })
}
const insert = (params) => {
  const { fish_url, token, appkey: appKey } = proxy.$store.state.fisherInfo
  return new Promise(resolve => {
    axios.post(`${fish_url}/jmc/material/insert`, params, {
      headers: {
        token,
        AppKey: appKey
      }
    })
      .then(res => {
        console.log('insert res', res, res.data.code, res.data.data)
        if (res.data.code === 0) {
          console.log(11)
          resolve([null, res.data.data])
        } else {
          resolve([res.data, null])
        }
      })
      .catch(err => {
        console.log('insert err', err)
        resolve(err, null)
      })
  })
}

</script>
